import { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { Colors, Theme } from '@app/theme';
import { TitleWithIcon } from '@app/core';

const useStyles = createUseStyles<string, {}, any>((theme: Theme) => ({
  descriptionContainer: {
    background: theme.colors.grayBackground,
    padding: theme.marginBase * 2,
    borderRadius: theme.borderRadius.std,
  },
  description: {
    ...theme.fonts.caption,
  },
}));

interface Props {
  title?: ReactNode;
  icon?: string;
  iconColor?: Colors;
  description?: ReactNode;
  children?: ReactNode;
}

export const InformationSection = ({
  title,
  icon,
  iconColor,
  description,
  children,
}: Props) => {
  const classes = useStyles();

  return (
    <section className={classes.section}>
      {title && icon && (
        <TitleWithIcon title={title} icon={icon} iconColor={iconColor} />
      )}
      {description && (
        <div className={classes.descriptionContainer}>
          <p className={classes.description}>{description}</p>
        </div>
      )}
      {children}
    </section>
  );
};
